"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var intl_messageformat_1 = require("intl-messageformat");
var React = require("react");
var internal_1 = require("../types/internal");
var intl_messageformat_parser_1 = require("intl-messageformat-parser");
var localizer_1 = require("../localizer");
var logger_1 = require("../common/logger");
var ICU = /** @class */ (function () {
    function ICU() {
        this.compileCache = {};
        this.partsCache = {};
    }
    ICU.prototype.formatString = function (key, params) {
        var translatedText = internal_1.internalStringLoader.getString(key);
        // There is no { in the string, which means that there is no point for further string processing
        if (translatedText.indexOf('{') === -1) {
            return translatedText;
        }
        // Fabric automation encourages to surround placeholders with {Locked="{PLACEHOLDER}"} to block translators
        // from removing spective part in translated string. Strip it, if present.
        translatedText = this._stripLocked(translatedText);
        params = params || {};
        this._validateParams(translatedText, params);
        try {
            return this._getCompiledTemplate(translatedText).format(params);
        }
        catch (e) {
            return '';
        }
    };
    ICU.prototype.formatComponent = function (key, params) {
        var translatedText = internal_1.internalStringLoader.getString(key);
        translatedText = this._stripLocked(translatedText);
        params = params || {};
        this._validateParams(translatedText, params);
        // We will replace parts that are not compatible with messageformat with themselves
        // ie. Hello, {NAME} and NAME is a react element, then NAME will be replaced with {NAME}
        // in the first messageformat iteration, so we can later replace with with React element
        var messageFormatCompatibleParams = this._getMessageFormatCompatibleParams(params);
        var translatedICUText;
        try {
            translatedICUText = this._getCompiledTemplate(translatedText).format(messageFormatCompatibleParams);
        }
        catch (e) {
            translatedICUText = '';
        }
        // 2nd messageformat iteration, now replce only React elements
        // > parse('So {wow}.')
        // [ { id: 'messageTextElement', value: 'So '}, { id: 'argumentElement', value: 'wow' }, { id: 'messageTextElement', value: '.'} ]
        var result = this._getCachedParts(translatedICUText).map(function (part) {
            if (part.type !== 'argumentElement') {
                return (part.type === 'messageTextElement') ? part.value : '';
            }
            // This is required for escaped args
            // In case first messageformat iteration replaced \{VARIABLE\} with {VARIABLE}
            // then here we should skip it aswell
            if (!params.hasOwnProperty(part.id)) {
                return '{' + part.id + '}';
            }
            return params[part.id];
        });
        if (result.length === 0) {
            return React.createElement('span', null, ''); // tslint:disable-line:no-null-keyword
        }
        return React.createElement.apply(React, ['span', null].concat(result)); // tslint:disable-line:no-null-keyword
    };
    ICU.prototype._stripLocked = function (input) {
        return input.replace(/{Locked="([^"]+)"}/g, '$1');
    };
    ICU.prototype._validateParams = function (input, params) {
        // > parse('So {wow}.')
        // [ 'So ', { type: 'argument', arg: 'wow' }, '.' ]
        var parts = this._getCachedParts(input);
        for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
            var part = parts_1[_i];
            if (part.type !== 'argumentElement') {
                continue;
            }
            if (!params.hasOwnProperty(part.id) || params[part.id] === undefined || params[part.id] === null) {
                logger_1.logger.error('Input string \'' + input + '\' doesn\'t contain value for argument ' + part.id);
                // Default fallback to empty string
                params[part.id] = '';
            }
        }
    };
    ICU.prototype._getMessageFormatCompatibleParams = function (params) {
        var formattingParams = {};
        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                var element = params[key];
                // MessageFormat library supports only date, string or number type
                if (typeof element === 'string' || element instanceof Date || typeof element === 'number') {
                    formattingParams[key] = element;
                }
                else {
                    // Replace parameters, that we don't know how to replace with itselves, otherwise
                    // we end up with undefined values
                    formattingParams[key] = '{' + key + '}';
                }
            }
        }
        return formattingParams;
    };
    ICU.prototype._getCachedParts = function (input) {
        if (!this.partsCache[input]) {
            try {
                this.partsCache[input] = intl_messageformat_parser_1.parse(input).elements;
            }
            catch (e) {
                logger_1.logger.error('Syntax error in translation ' + input);
                return [];
            }
        }
        return this.partsCache[input];
    };
    ICU.prototype._getCompiledTemplate = function (input) {
        var locale = localizer_1.localizer.getLocale();
        if (!this.compileCache[input]) {
            try {
                this.compileCache[input] = new intl_messageformat_1.default(input, locale);
            }
            catch (e) {
                logger_1.logger.error('Syntax error in translation ' + input);
                this.compileCache[input] = {
                    format: function () {
                        return '';
                    }
                };
            }
        }
        return this.compileCache[input];
    };
    return ICU;
}());
exports.ICU = ICU;
exports.default = new ICU();
